import { defineMessages } from 'react-intl';

export default defineMessages({
    veriskErrorMessage: {
        id: 'ml.quoteandbind.ho.ConstructionPage.Something went wrong processing home details',
        defaultMessage: 'Something went wrong processing home details'
    },
    tryAgainMessage: {
        id: 'ml.quoteandbind.ho.ConstructionPage.Please try again.',
        defaultMessage: 'Please try again.'
    },
    unableToSaveSubmission: {
        id: 'ml.quoteandbind.ho.ConstructionPage.Unable to save submission',
        defaultMessage: 'Unable to save submission'
    },
    saveSubmissionError: {
        id: 'ml.quoteandbind.ho.ConstructionPage.An error occurred while attempting to save quote submission.',
        defaultMessage: 'An error occurred while attempting to save quote submission.'
    },
    nextLabel: {
        id: 'ml.quoteandbind.ho.ConstructionPage.We’ll work on your discount next',
        defaultMessage: 'We\'ll work on your {discount} next'
    },
    discountLabel: {
        id: 'ml.quoteandbind.ho.ConstructionPage.discounts',
        defaultMessage: 'discounts'
    },
    crNextLabel: {
        id: 'ml.quoteandbind.ho.ConstructionPage.We’ll review your quote next',
        defaultMessage: 'We\'ll {quote} next!'
    },
    crQuoteLabel: {
        id: 'ml.quoteandbind.ho.ConstructionPage.review your quote',
        defaultMessage: 'review your quote'
    },
    homeDetailsHeader: {
        id: 'ml.quoteandbind.ho.ConstructionPage.Details about your home',
        defaultMessage: 'Details about your home'
    },
    condoDetailsHeader: {
        id: 'ml.quoteandbind.ho.ConstructionPage.Details about your condo',
        defaultMessage: 'Details about your condo'
    },
    somethingWentWrong: {
        id: 'ml.quoteandbind.ho.ConstructionPage.Something went wrong during this process.  Please try again.',
        defaultMessage: 'Something went wrong during this process.  Please try again.'
    },
    veriskTokenErrorMessage: {
        id: 'ml.quoteandbind.ho.ConstructionPage.Verisk Token Error',
        defaultMessage: 'Unable to retrieve the property valuation at this time.'
    },
    yearBuild: {
        id: 'ml.quoteandbind.ho.ConstructionPage.YearBuilt',
        defaultMessage: 'Year Built'
    },
    squareFootage: {
        id: 'ml.quoteandbind.ho.ConstructionPage.squareFootage',
        defaultMessage: 'Total Finished Square Feet'
    },
    veriskValuationFailed: {
        id: 'quoteandbind.ho.construction.veriskValuationFailed',
        defaultMessage: 'Unable to retrieve Verisk property valuation. Please try again.'
    },
    veriskValuationResponseInvalid: {
        id: 'quoteandbind.ho.construction.veriskValuationResponseInvalid',
        defaultMessage: 'Verisk valuation response is missing required details.'
    },
    veriskValuationServiceError: {
        id: 'quoteandbind.ho.construction.veriskValuationServiceError',
        defaultMessage: 'Something went wrong while retrieving Verisk valuation. Please try again.'
    },
    yearBuildRequired: {
        id: 'quoteandbind.ho.construction.yearBuildRequired',
        defaultMessage: 'Year built is required'
    },
    yearBuildOnlyNumbers: {
        id: 'quoteandbind.ho.construction.yearBuildOnlyNumbers',
        defaultMessage: 'Enter valid year built'
    },
    actualSquareFootageRequired: {
        id: 'quoteandbind.ho.construction.actualSquareFootageRequired',
        defaultMessage: 'Actual square footage is required'
    },
    actualSquareFootageOnlyNumbers: {
        id: 'quoteandbind.ho.construction.actualSquareFootageOnlyNumbers',
        defaultMessage: 'Enter valid actual square footage'
    }
});
